import Pill from "PFComponents/pill/pill";
import StarIcon from "PFIcons/star_2.svg";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./interested_pill.module.scss";

const InterestedPill = (): JSX.Element => {
  const { t } = useTranslation("activities", { keyPrefix: "show.matches" });

  return (
    <Pill>
      <div className={css.interestedPill}>
        <StarIcon height={13} />
        {t("interested")}
      </div>
    </Pill>
  );
};

export default InterestedPill;
